import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import { getPayouts } from '@severed-links/common.redherrings-reducers/football'
import numeral from 'numeral'
import pluralize from 'pluralize'
import * as s from './Payouts.scss'
import { teamUrl, playerUrl } from '@severed-links/common.redherrings-constants'

const Payouts = () => {

    const dispatch = useDispatch()
    const params = useParams()
    const [expandedType, setExpandedType] = useState(null)
    const seasonName = params.seasonName || null
    const seasons = useSelector(state => state.football.seasons)
    const season = seasons.find(i => i.seasonName === seasonName)
    const seasonId = (season || {}).seasonId || null
    const payouts = useSelector(state => state.football.payouts.find(i => i.seasonName === seasonName))

    useEffect(() => { seasonId ? dispatch(getPayouts(seasonId)) : null }, [seasonId])

    if (!payouts) return null
    const { items } = payouts
    return (
        <div className={s.container}>
            <div className={s.hero}>
                <div className={s.heroIcon}><FontAwesomeIcon name='money-bill' /></div>
                <div className={s.heroContent}>
                    <div className={s.eyebrow}>Football</div>
                    <h2 className={s.title}>Payouts</h2>
                    <div className={s.subtitle}>{seasonName} payout schedule</div>
                </div>
            </div>
            <div className={s.list}>
                <div className={s.listHeader}>
                    <div>
                        <h3>Payout schedule</h3>
                        <div>{pluralize('item', items?.length || 0, true)}</div>
                    </div>
                </div>
            {items && items.map(i => {
                const winnerCount = i.winners?.length || 0
                return (
            <div className={s.item + ' ' + s[`${i.type}`]} key={`payout-${seasonName}-${i.type}`}>
                <div className={s.content}>
                    <div className={s.descriptionContainer}>
                        <div className={s.description}>{i.item}</div>
                        {i.amount ? <div className={s.rate}>{numeral(Math.abs(i.amount)).format('$0,0.00')}{i.num > 1 ? `/each` : ``}</div> : null}
                    </div>
                    {winnerCount ?
                    <button className={s.winnerToggle} type='button' onClick={() => setExpandedType(expandedType === i.type ? null : i.type)}>
                        <FontAwesomeIcon name='search' />
                        <span>{pluralize('winner', winnerCount, true)}</span>
                    </button>
                    : null}
                    <div className={s.amountContainer + (!i.balance ? ` ${s.zero}` : '')}>
                        {numeral(i.balance).format('$0,0.00')}
                    </div>
                </div>
                {winnerCount && expandedType === i.type ?
                        <div className={s.detail}>
                            <div className={s.winners}>
                            {i.winners && i.winners.map((w, _winnerIndex) => 
                                <div className={s.winner} key={`payouts-${seasonName}-${i.type}-winner-${_winnerIndex}`}>
                                    {i.type === 'weekly' ? <div className={s.weekContainer}><div className={s.weekHeading}>Week</div><div className={s.weekNumber}>{w.week}</div></div> : null}
                                    <div className={s.avatar} style={{ backgroundImage: `url(${teamUrl(w.avatarUrl)})` }} />
                                    <div className={s.avatar} style={{ backgroundImage: `url(${playerUrl(w.playerAvatarUrl)})` }} />
                                    <div className={s.names}>
                                        <div className={s.teamName}>{w.teamName}</div>
                                        <div className={s.playerName}>{w.firstName} {w.lastName}</div>
                                    </div>
                                </div>
                            )}
                            </div>
                        </div>
                        : null}
            </div>
                )
            })}
            {!items || !items.length ? <div className={s.item}>No payouts located for {seasonName}.</div> : null}
            </div>
        </div>
    )
}

export default Payouts
